import { createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../_helpers/_methods';
import { fetchFiscalYear } from './fiscalyear';

export const initialState = {
  loading: false,
  hasErrors: false,
  results: [],
  pageNum: 0,
  pageSize: 10,
  totalCount: null
};

// A slice
const tableSlice = createSlice({
  name: 'table',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setPageNum: (state, action) => {
      state.pageNum = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload;
    },
    setResults: (state, action) => {
      state.results = action.payload;
    },
    clearTableData: (state) => {
      state.results = [];
      state.pageNum = 0;
      state.pageSize = 10;
      state.totalCount = null;
    },
    deleteTableData: (state, action) => {
      const tempResults = [...state.results];
      const index = tempResults.findIndex((result) => result.id === action.payload);
      tempResults.splice(index, 1);
      state.results = tempResults;
    },
    createTableData: (state, action) => {
      state.results.push(action.payload);
    },
    editTableData: (state, action) => {
      const editedData = [...state.results];
      const editedIndex = editedData.findIndex((result) => result.id === action.payload.id);
      if (editedIndex !== -1) {
        editedData[editedIndex] = action.payload;
      }
      state.results = editedData;
    },
    //only for sector type
    createTableSubCategory: (state, action) => {
      const data = state.results.find((result) => result.id === action.payload.parent);
      const newResults = state.results.filter((result) => result.id !== action.payload.parent);
      if (data) {
        data.sector_childrens.push(action.payload);
        newResults.push(data);
      }
      state.results = newResults;
    }
  }
});

// Actions generated from the slice
const {
  setPageNum,
  setPageSize,
  setTotalCount,
  setLoading,
  setResults,
  clearTableData,
  deleteTableData,
  createTableData,
  editTableData,
  createTableSubCategory
} = tableSlice.actions;

// export user selector to get the slice in any component
export const tableSelector = (state) => state.table;

// export The reducer
const tableReducer = tableSlice.reducer;

export default tableReducer;

// Actions
export { deleteTableData, createTableData, editTableData, createTableSubCategory };
export const handlepageNumChange = (index) => (dispatch) => {
  dispatch(setPageNum(index));
};
export const handlePageSizeChange = (size) => (dispatch) => {
  dispatch(setPageSize(size));
};
export const handleTotalCountChange = (count) => (dispatch) => {
  dispatch(setTotalCount(count));
};
export const handleResultsChange =
  ({ index, eventState, activeTab, pageSize, isMtot, isVirtual, isPhysical, eventType }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      // let url = '/all-event/';
      let url;
      url = '/event/';
      if (activeTab === 'my_events') {
        url = '/my-events/';
      }
      if (pageSize) {
        url += `?limit=${pageSize}`;
      } else {
        url += `?limit=50`;
      }

      if (eventState) {
        url += `&type=${eventState}`;
      }
      if (index) {
        url += `&page=${index}`;
      }
      if (isMtot) {
        url += '&mtot=true';
      }
      if (isVirtual) {
        url += '&nature=online';
      }
      if (isPhysical) {
        url += '&nature=physical';
      }
      if (eventType && eventType !== 'clear') {
        url += `&program_type=${eventType}`;
      }
      const isPublic = eventType === 'public/open';

      const response = await fetchWrapper.get(url, isPublic);
      const { results, count } = response.data;
      dispatch(setResults(results));
      dispatch(setTotalCount(count));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };

export const handleRosterListChange =
  ({ index, pageSize }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      let url = '/profile/resource-person/?approved=true&type=individual';
      if (index) {
        url += `&page=${index}`;
      }
      if (pageSize) {
        url += `&limit=${pageSize}`;
      }

      const response = await fetchWrapper.get(url);
      const { results, count } = response.data;
      dispatch(setResults(results));
      dispatch(setTotalCount(count));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };
export const handleOrganizationRosterListChange =
  ({ index, pageSize }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      let url = '/profile/resource-person/?approved=true&type=department&suspended=false';
      if (index) {
        url += `&page=${index}`;
      }
      if (pageSize) {
        url += `&limit=${pageSize}`;
      }

      const response = await fetchWrapper.get(url);
      const { results, count } = response.data;
      dispatch(setResults(results));
      dispatch(setTotalCount(count));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };

export const handlePendingRosterListChange =
  ({ index, pageSize }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      let url = '/profile/resource-person/?approved=false';
      if (index) {
        url += `&page=${index}`;
      }
      if (pageSize) {
        url += `&limit=${pageSize}`;
      }

      const response = await fetchWrapper.get(url);
      const { data } = response;
      dispatch(setResults(data.results));
      dispatch(setTotalCount(data.count));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };

export const handleSuspendedRosterListChange =
  ({ index, pageSize }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      let url = '/profile/resource-person/?suspended=true';
      if (index) {
        url += `&page=${index}`;
      }
      if (pageSize) {
        url += `&limit=${pageSize}`;
      }

      const response = await fetchWrapper.get(url);
      const { data } = response;
      dispatch(setResults(data.results));
      dispatch(setTotalCount(data.count));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };

export const handleSuperUserListChange =
  ({ index, pageSize = 50 }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      let url = '/profile/superuser/';
      if (index) {
        url += `?page=${index}`;
      } else if (pageSize) {
        url += `?limit=${pageSize}`;
      }

      const response = await fetchWrapper.get(url);
      const { data } = response;
      dispatch(setResults(data.results));
      dispatch(setTotalCount(data.count));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };

export const handleCdAdminListChange =
  ({ index, pageSize = 50 }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      let url = '/profile/cd-admin/';
      if (index) {
        url += `?page=${index}`;
      } else if (pageSize) {
        url += `?limit=${pageSize}`;
      }

      const response = await fetchWrapper.get(url);
      const { data } = response;
      dispatch(setResults(data.results));
      dispatch(setTotalCount(data.count));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };
export const handleThematicAreaListChange =
  ({ index, pageSize }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      let url = '/thematicarea/';
      if (index) {
        url += `?page=${index}`;
      }
      if (pageSize) {
        url += `?limit=${pageSize}`;
      }

      const response = await fetchWrapper.get(url);
      const { count, results } = response.data;
      dispatch(setResults(results));
      dispatch(setTotalCount(count));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };
export const handleEmployeeTypeListChange =
  ({ index, pageSize }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      let url = '/employee-type/';
      if (index) {
        url += `?page=${index}`;
      } else if (pageSize) {
        url += `?limit=${pageSize}`;
      }

      const response = await fetchWrapper.get(url);
      const { data, count } = response;
      dispatch(setResults(data.results));
      dispatch(setTotalCount(count));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };
export const handleEmployeeLevelListChange =
  ({ index, pageSize }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      let url = '/employee-type/children/';
      if (index) {
        url += `?page=${index}`;
      } else if (pageSize) {
        url += `?limit=${pageSize}`;
      }

      const response = await fetchWrapper.get(url);
      const { data, count } = response;
      dispatch(setResults(data.results));
      dispatch(setTotalCount(count));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };

export const handleSectorTypeListChange =
  ({ index, pageSize }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      let url = '/sector/';
      if (index) {
        url += `?page=${index}`;
      } else if (pageSize) {
        url += `?limit=${pageSize}`;
      }

      const response = await fetchWrapper.get(url);
      const { data, count } = response;
      dispatch(setResults(data.results));
      dispatch(setTotalCount(count));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };
export const handleFiscalYearListChange =
  ({ index, pageSize }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      let params = '';
      if (index) {
        params += `?page=${index}`;
      } else if (pageSize) {
        params += `?limit=${pageSize}`;
      }

      dispatch(fetchFiscalYear(params));

      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };
export const handleOfficeKindListChange =
  ({ index, pageSize }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      let url = '/office-type/';
      if (index) {
        url += `?page=${index}`;
      } else if (pageSize) {
        url += `?limit=${pageSize}`;
      }

      const response = await fetchWrapper.get(url);
      const { data } = response;
      dispatch(setResults(data.results));
      dispatch(setTotalCount(data.count));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };

export const handleExecutiveListChange =
  ({ index, size = 50 }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      let url = '/profile/executive/';
      if (index) {
        url += `?page=${index}`;
      } else if (size) {
        url += `?limit=${size}`;
      }

      const response = await fetchWrapper.get(url);
      const { data } = response;
      dispatch(setResults(data.results));
      dispatch(setTotalCount(data.count));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };

export const handleParticipantListChange =
  ({ index, pageSize }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      let url = '/profile/participant/';
      if (index) {
        url += `?page=${index}`;
      } else if (pageSize) {
        url += `?limit=${pageSize}`;
      }

      const response = await fetchWrapper.get(url);
      const { data } = response;
      dispatch(setResults(data.results));
      dispatch(setTotalCount(data.count));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };
export const clearTable = () => async (dispatch) => {
  {
    dispatch(clearTableData());
  }
};

export const handleTableData =
  ({ url, index, size = 50, name, phone, params }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      if (index) {
        let offSet = (index - 1) * size;
        if (offSet === 0) {
          url += `?page=${index}&limit=${size}`;
        } else {
          url += `?offset=${offSet}&page=${index}&limit=${size}`;
        }
      } else if (size) {
        url += `?limit=${size}`;
      }
      if (name) {
        url += `&fullname=${name}`;
      }
      if (phone) {
        url += `&phone=${phone}`;
      }
      url += params ? params : '';

      const response = await fetchWrapper.get(url);
      const { data } = response;
      const { count, results } = data;

      dispatch(setResults(results));
      dispatch(setTotalCount(count));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };
